import React from 'react';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.05); opacity: 0.8; }
  100% { transform: scale(1); opacity: 0.5; }
`;

const ShapeWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  z-index: ${props => props.zIndex || 0};
  animation: ${float} ${props => props.duration || '6s'} ease-in-out infinite;
  ${props => props.customStyles};
`;

const Circle = styled.div`
  width: ${props => props.size || '50px'};
  height: ${props => props.size || '50px'};
  border-radius: 50%;
  background: ${props => props.color || '#000'};
  opacity: 0.5;
  animation: ${pulse} 4s ease-in-out infinite;
`;

const Square = styled.div`
  width: ${props => props.size || '50px'};
  height: ${props => props.size || '50px'};
  background: ${props => props.color || '#000'};
  opacity: 0.5;
  transform: rotate(45deg);
  animation: ${pulse} 4s ease-in-out infinite;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: ${props => props.size || '25px'} solid transparent;
  border-right: ${props => props.size || '25px'} solid transparent;
  border-bottom: ${props => props.size || '50px'} solid ${props => props.color || '#000'};
  opacity: 0.5;
  animation: ${pulse} 4s ease-in-out infinite;
`;

const AnimatedShape = ({
    type = 'circle',
    size,
    color,
    position,
    duration,
    delay = '0s',
    zIndex,
    customStyles = ''
}) => {
    const shapeStyles = {
        animationDelay: delay,
        ...position
    };

    const renderShape = () => {
        switch (type) {
            case 'square':
                return <Square size={size} color={color} />;
            case 'triangle':
                return <Triangle size={size} color={color} />;
            default:
                return <Circle size={size} color={color} />;
        }
    };

    return (
        <ShapeWrapper
            style={shapeStyles}
            duration={duration}
            zIndex={zIndex}
            customStyles={customStyles}
        >
            {renderShape()}
        </ShapeWrapper>
    );
};

export default AnimatedShape; 